// extracted by mini-css-extract-plugin
module.exports = {"landing_page":"LandingPage_landing_page__bKevX"};